// console.debug('CDNOverride', localStorage.getItem('CDN_DISABLED'));
export const CDN_ENABLED = () => {
  return process.env['REACT_APP_CDN_API'] === 'true' && localStorage.getItem('CDN_DISABLED') !== 'true';
};
export const CDN_ONLY = process.env['REACT_APP_CDN_ONLY'] === 'true';
export const IS_DEV = process?.env?.NODE_ENV === 'development';

export const LOG_TIMING = IS_DEV && process.env['REACT_APP_LOG_TIMING'] === 'true' ? true : false;

export const IS_SNAP = navigator.userAgent === 'ReactSnap';

export const LAZY_IMAGE_ENABLED = process.env['REACT_APP_LAZY_IMAGE'] === 'true';
export const IS_MAINTENANCE_MODE = process.env['REACT_APP_MAINTENANCE_MODE'] === 'true' && localStorage.getItem('IGNORE_MAINTENANCE') !== 'true';
export const PRIMARY_DOMAIN = process.env['REACT_APP_PRIMARY_DOMAIN'] || 'card.gift';
